import { useEffect, useState } from "react";
import useMounted from "../useMounted";
import { getVariant, tryIt } from "./utils";

const selection = (agent, result) => result?.data?.sels?.[agent];

const metadata = (agent, result) => {
    const c = selection(agent, result);
    return result?.data?.items?.find((item) => item.a === agent && item.c === c)
        .md; //find and return metadata
};

const asInt = (agent, result) => {
    const A_CHAR_CODE = 65;
    const sel = selection(agent, result) ?? "";
    return Math.max(0, sel.charCodeAt(0) - A_CHAR_CODE) + 1 || 0;
};

const FORMAT = {
    selection,
    metadata,
    asInt,
};

const useABTest = (agent, format = FORMAT.selection, condition = true) => {
    const [selection, setSelection] = useState(null);
    const mounted = useMounted();
    useEffect(() => {
        if (agent && mounted && selection === null && condition) {
            tryIt(getVariant, agent, (result) => {
                if (mounted) {
                    setSelection(tryIt(format, agent, result));
                }
            });
        }
    }, [agent, mounted, condition, format]);

    return selection;
};

useABTest.FORMAT = FORMAT;

export default useABTest;
